// @ts-nocheck
import { getSndGrades } from "@store/Framework/Services/ScratchAndDentService";
import { SndGrades } from "@store/Framework/Types/ApiModels";
import {
    ApiHandler,
    createHandlerChainRunnerOptionalParameter,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<HasOnSuccess & HasOnError<string>, SndGrades>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getSndGrades();
    } catch (error) {
        if ("errorMessage" in error) {
            props.parameter.onError?.(error.errorMessage as string);
        }

        return false;
    }
};

export const DispatchSetSndGrades: HandlerType = props => {
    props.dispatch({
        type: "Store/Components/ScratchAndDentForm/SetSndGrades",
        sndGrades: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchSetSndGrades, ExecuteOnSuccessCallback];

const setSndGrades = createHandlerChainRunnerOptionalParameter(chain, {}, "SetSndGrades");
export default setSndGrades;
